const plusFeatureTriggers = [
  'Distance Away',
  'Download the Route',
  'Flyover',
  'trail conditions weather along the trail upsell card tapped',
  'trail conditions ground conditions upsell card tapped',
  'trail conditions mosquito activity upsell card tapped',
  'Live Share',
  'Guide',
  'Guide Index',
  'Send Routes To Garmin',
  'Hit the Trail Card Download Map',
  'Hit the Trail Card Live Share',
  'Gallery Tour'
];

export default plusFeatureTriggers;
